<template>
<div>
  <cur-location :location="location"/>
  <div class="article-detail">
    <div class="container">
        <div class="box-title">{{article.title}}
          <div class="msg">
            <span>发布时间：{{article.addtime}}</span>
            <span>作者：{{article.author}}</span>
            <span>阅读量：{{article.artvisits}}</span>
        </div>
        </div>
        
        <div class="text">
            <div class="title"></div>
            <div class="desc" v-html="article.contentHtml">
                
            </div>
        </div>
    </div>
  </div>
</div>
</template>
<script>
import CurLocation from "../components/PublicComs/CurLocation.vue";
import global from "@/components/PublicComs/Common.vue";
import RightNews from '../components/PublicComs/RightNews.vue';
const rate= window.innerWidth/1240;
export default {
  metaInfo: {
    meta: [
      { name:'viewport', content:
      `width=device-width, user-scalable=yes, initial-scale=${rate}, maximum-scale=${10}, minimum-scale=${rate}`}
    ]
  },
  props: {
    plates:Array
  },
  components: { CurLocation, RightNews},
  data() {
    return {
      location: {
        name: "",
        link: "",
        type: "info",
      },
      global,
      article: {},
      Groups:[
          {
            name: "协会动态"
          },{
            name: "行业动态"
          }
        ],
      isPhone:global.isPhone()
    };
  },

  created() {
    let plateId = this.$route.params.plateId;
    this.location.link = `/news/views/${plateId}`;
    let plates = this.plates;
    for (let i = 0; i < plates.length; i++) {
      if ((plateId == plates[i]._id)) {
        this.location.name = plates[i].name;
        break;
      }
    }
    let articleId = this.$route.params.articleId;
    if(articleId == "000000")
    {
      this.$axios.get(`/api/categorys/${plateId}/articles`).then((res) => {
        if (res.data) {
          let  articles = res.data.data;
          if(articles.length==0) return;
          this.$axios.get(`/api/articles/${articles[0]._id}`).then((res) => {
            if (res.data) {
              this.article = res.data.data;
              if(!this.article.addtime)
              {
                let addtime = this.article.createdAt;
                let date = new Date(addtime);
                this.article.addtime=`${date.getFullYear()}-${("00"+(date.getMonth()+1)).slice(-2)}-${("00"+date.getDate()).slice(-2)} ${("00"+date.getHours()).slice(-2)}:${("00"+date.getMinutes()).slice(-2)}:${("00"+date.getSeconds()).slice(-2)}`
              }
              this.$nextTick(()=>{
                  document.title =this.article.title;
                  document.description =this.article.description;
              document.keywords =this.article.keywords;
              })
            }
          });
        }
      });
    }else
    {
      this.$axios.get(`/api/articles/${articleId}`).then((res) => {
        if (res.data) {
          this.article = res.data.data;
          if(!this.article.addtime)
          {
            let addtime = this.article.createdAt;
            let date = new Date(addtime);
            this.article.addtime=`${date.getFullYear()}-${("00"+(date.getMonth()+1)).slice(-2)}-${("00"+date.getDate()).slice(-2)} ${("00"+date.getHours()).slice(-2)}:${("00"+date.getMinutes()).slice(-2)}:${("00"+date.getSeconds()).slice(-2)}`
          }
          this.$nextTick(()=>{
              document.title =this.article.title;
              document.description =this.article.description;
              document.keywords =this.article.keywords;
          })
        }
      });
    }
    for(let k = 0; k <this.Groups.length; k++)
    {
      for(let j = 0; j < this.plates.length; j++)
      {
        
        if(this.Groups[k].name == this.plates[j].name)
        {
          this.Groups[k].plateId = this.plates[j]._id;
          this.$axios.get(`/api/articles?plateid=${this.Groups[k].plateId}&sort=-createdAt`).then((res) => {
            if(res.data) 
            {
                 this.Groups[k].articles=this.global.sortByTop(res.data.data).slice(0,6);
            }
          })
          break;
        }
      }
    }
  },

  methods: {
    toTop(){
        document.body.scrollTop =0;
        document.documentElement.scrollTop = 0;
    }
  },
beforeDestroy(){
  this.toTop();
},
  computed: {},

  mounted() {
    
  },

  watch: {},
};
</script>
<style scoped>
.desc{
  margin-bottom: 50px;
}
.article-detail .msg{
      text-align: right;
    color: #BDBDBD;
    margin-top: 28px;
    margin-bottom:0px;
}
.article-detail{
  background-color: #ffffff;
}
</style>